import { useSetPageTitle } from "../../hooks/useSetPageTitle";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/redux-store";
import {useIsMobile} from "../../hooks/useMobile";
import DashboardSurveyList from "./components/dashboard-survey-list.component";
import DashboardSurveyTable from "./components/dashboard-survey-table.component";
import {SidebarProvider, SidebarTrigger} from "../../components/ui/sidebar";
import DashboardSidebar from "./components/dashboard-sidebar";
import { DashboardMenubar } from "src/components/menubar/menubar";

const Dashboard = () => {
  useSetPageTitle('Dashboard');
  const { isMobile } = useIsMobile();
  const firstName = useSelector((state: RootState) => state.userState.firstName);

  return (
    <SidebarProvider>
      <DashboardSidebar activePage="/dashboard" />
      <div className="flex flex-col w-full grow p-4 md:p-10 gap-6 min-h-screen">
        <div className="flex gap-4">
          {isMobile && (
            <div className="flex size-12 items-center justify-center">
              <SidebarTrigger />
            </div>
          )}
          <span className="text-3xl mt-2 md:text-5xl md:mt-0">
            {`Welcome back!`}
          </span>
          <div className="items-end ml-auto">
            <DashboardMenubar />
          </div>
        </div>
        {isMobile ? <DashboardSurveyList /> : <DashboardSurveyTable />}
      </div>
    </SidebarProvider>
  );
};

export default Dashboard;
